import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Progress, Row, Spin, Popover } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { RootState } from '../../../../../../../store';
import { getDateWithTextMonth } from '../../../../../../../utils/dateTimeUtils';
import { ReactComponent as TickIcon } from '../../../../../../../assets/images/svg/green-tick-icon.svg';
import { nameFormat } from '../../../../../../../utils/utility';
import { BENEF_POLICY_NO_RPA_PAYERS, GENERIC_DISABLED_BENEF_MESSAGE } from '../../../../../../../shared/constants/crmConstants';
import { breakMessage } from '../../../../service/crmUtils';
const BeneficiaryCardRedesign =
  ({ beneficiary, isSelected, index, loading, isBeneficiaryPopUpRequired, isConfirmed, disabled, starDisabledBenefMessage }: any):
    ReactElement => {
    useSmoothScroll('scroll-benef');
    const {
      memberName, memberId,
      policyStartDate, policyEndDate, policyHolderName,
      status, policyNo, percentageNameMatch, productName,
    } = beneficiary;
    const {
      payerList: { payer: { shortName }, formControlConfig },
    } = useSelector((state: RootState): RootState => state);
    const [isShowFields, setIsShowFields] = useState(false);
    const payerConfigValues = Object.values(formControlConfig);
    const  productNameTobeShown = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
    const starDisabledBeneficiaryMessage = breakMessage(starDisabledBenefMessage, 50);
    const getDate = (date: any): string => {
      const dateFormatted = getDateWithTextMonth(date);
      return dateFormatted === 'Invalid date' ? '-' : dateFormatted;
    };
    const getColor = (): any => {
      return percentageNameMatch >= 90 ? '#2AE1AA' : percentageNameMatch >= 60 ? '#F2BA29' : '#E15554';
    };
    useEffect((): void => {
      const isPresent = payerConfigValues?.filter(({ type }: any): any => type === 'bajaj');
      isPresent?.length > 0 ? setIsShowFields(false) : setIsShowFields(true);
    }, []);
    return (
      <Popover
        content={
          <span className="card-tooltip-content">
            {disabled
              ? productNameTobeShown ? (
                <>
                {starDisabledBeneficiaryMessage?.map((line: any, indexItem: any): any => (
                  <span key={indexItem}>
                    {line}
                    {index !== starDisabledBeneficiaryMessage?.length - 1 && <br />}
                  </span>
                ))}
              </>
              ) : GENERIC_DISABLED_BENEF_MESSAGE
              : 'Click on card to select'}
          </span>}
        placement="top"
      >
        <Card data-testid="benefCard"
          className={`scroll-benef NA-beneficiary-card panel-styles
        ${isConfirmed ? 'benef-card-selected' : ''} ${disabled ? 'disable-cards' : ''} card-selected mb-md`} hoverable={true}>
          <Col className="re-design-selected-Svg-Icon benef">
            {isConfirmed && <TickIcon />}
          </Col>
          <Row
            className="beneficiary-card-header"
          />
          <Row className="beneficiary-card-content">
            <Col md={18} className="beneficiary-card-data">
              <Row className="m-b-5">
                <Col md={9} className="beneficiary-title">Patient Name</Col>
                <Col className="beneficiary-values" md={15}>
                  {nameFormat(memberName) || '-'}</Col>
              </Row>
              <Row className="m-b-5">
                <Col md={9} className="beneficiary-title">Member ID  </Col>
                <Col md={15} className="beneficiary-values">{memberId || '-'}</Col>
              </Row>
              {isShowFields && <Row className="m-b-5">
                <Col md={9} className="beneficiary-title">Policy Holder  </Col><Col md={15} className="beneficiary-values">
                  {policyHolderName || '-'}</Col>
              </Row>}
              {isShowFields && <Row className="m-b-5">
                <Col md={9} className="beneficiary-title">Policy Date </Col>
                {policyStartDate && policyEndDate ? (<Col md={15} className="beneficiary-values value-font attention policy-padding">
                  {getDate(policyStartDate) || '-'} {policyStartDate ? 'to' : ''} {getDate(policyEndDate) || '-'}
                </Col>) : '-'
                }
              </Row>}
              {BENEF_POLICY_NO_RPA_PAYERS.includes(shortName) && (
                <Row className="m-b-5">
                  <Col md={9} className="beneficiary-title">
                    Policy Number:
                  </Col>
                  <Col md={15} className="beneficiary-values">{policyNo || '-'}</Col>
                </Row>
              )}
              {productNameTobeShown && (
                <Row className="m-b-5">
                  <Col md={9} className="beneficiary-title">
                    Product Name
                  </Col>
                  <Col md={15} className="beneficiary-values">{productName || '-'}</Col>
                </Row>
              )}
              {status &&
                <Row className="m-b-5">
                  <Col md={9} className="beneficiary-title">Status: </Col><Col md={15} className="beneficiary-values">
                    {status || '-'}</Col>
                </Row>
              }
            </Col>
            {isBeneficiaryPopUpRequired &&
              <Col className="benef-doct-img" md={6}>
                <Progress type="circle" percent={percentageNameMatch > 0 ?
                  percentageNameMatch : 100} strokeColor={getColor()} strokeWidth={15} width={40}
                  format={(): any => `${percentageNameMatch}%`} />
                <div>
                  Name Match
                </div>
              </Col>
            }
          </Row>

          <Row justify="end">
            <div className="spin-container">
              {
                isSelected && loading &&
                <Spin indicator={<LoadingOutlined className="card-loading-icon" spin={true} />} />
              }
            </div>
          </Row>
        </Card>
      </Popover>
    );
  };

export default BeneficiaryCardRedesign;
